'use strict';

export function dyanne_platformScrollText( element ) {
        
    const scrollDirection = element.getAttribute('data-scroll-direction');

    gsap.to(element, {
        x: () => ( 'left' === scrollDirection ) ? -100 : 100,
        ease: "none",
        scrollTrigger: {
            trigger: element.parentNode,
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
            markers: false,
        }
    });

}